import {forwardRef} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Container = forwardRef(({className, children, asElement: Component = 'div', ...rest}, ref) => {
    return (
        <Component ref={ref} className={classNames('container mx-auto', className)} {...rest}>
            {children}
        </Component>
    )
})

Container.propTypes = {
    asElement: PropTypes.string,
}

export default Container
